export default "__VITE_ASSET__D4kG3XMj__"